import { alpha, Theme } from '@mui/material/styles';
import { Directions } from '../../common';

// ----------------------------------------------------------------------

export default function Input(theme: Theme) {
    return {
        MuiInputBase: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        '& svg': {
                            color: theme.palette.text.disabled,
                        },
                    },
                    '&.MuiInputBase-sizeSmall': {
                        height: theme.componentSizes.small,
                        lineHeight: 'normal',
                    },
                    '&.MuiInputBase-sizeMedium': {
                        height: theme.componentSizes.medium,
                        lineHeight: 'normal',
                    },
                    '&.MuiOutlinedInput-root': {
                        paddingLeft: 0,
                    },
                },
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        color: theme.palette.text.disabled,
                    },
                    lineHeight: 'normal',
                    '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus':
                        {
                            WebkitBoxShadow:
                                '0 0 0 100px transparent inset !important',
                            WebkitTextFillColor: theme.palette.text.primary,
                            transition: 'background-color 5000s ease-in-out 0s',
                            appearance: 'none',
                            backgroundColor: 'transparent !important',
                            WebkitBackgroundClip: 'text !important',
                            backgroundClip: 'text !important',
                        },
                    '&.MuiOutlinedInput-input': {
                        padding: '8.5px 14px',
                    },
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    '&:before': {
                        borderBottomColor: alpha(theme.palette.grey[500], 0.56),
                    },
                    '&:after': {
                        borderBottomColor: theme.palette.text.primary,
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiInputLabel-root.Mui-focused': {
                        color: theme.palette.text.primary,
                    },
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    borderRadius: theme.shape.borderRadius,
                    backgroundColor: alpha(theme.palette.grey[500], 0.08),
                    '&:hover': {
                        backgroundColor: alpha(theme.palette.grey[500], 0.16),
                    },
                    '&.Mui-focused': {
                        backgroundColor: alpha(theme.palette.grey[500], 0.16),
                    },
                    '&.Mui-disabled': {
                        backgroundColor:
                            theme.palette.action.disabledBackground,
                    },
                },
                underline: {
                    '&:before, :after': {
                        display: 'none',
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-notchedOutline': {
                        ...(theme.direction === Directions.rtl && {
                            textAlign: 'right',
                        }),
                        borderColor: alpha(theme.palette.grey[500], 0.32),
                    },
                    '&.Mui-focused': {
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderWidth: 1,
                            borderColor: theme.palette.text.primary,
                        },
                    },
                    '&.Mui-disabled': {
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor:
                                theme.palette.action.disabledBackground,
                        },
                    },
                },
            },
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    marginLeft: 0,
                    marginInlineStart: '8px',
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    '& .MuiInputLabel-root': {
                        '&.MuiInputLabel-sizeMedium': {
                            transform: 'translate(14px, 9px) scale(1)',
                        },
                        '&.MuiInputLabel-sizeMedium.Mui-focused': {
                            transform: 'translate(14px, -9px) scale(0.75)',
                        },
                        '&.MuiInputLabel-sizeMedium.MuiFormLabel-filled': {
                            transform: 'translate(14px, -9px) scale(0.75)',
                        },
                    },
                    ...(theme.direction === Directions.rtl && {
                        '& .MuiInputLabel-root': {
                            insetInlineStart: 0,
                            transformOrigin: 'top right',
                            '&.MuiInputLabel-sizeSmall.Mui-focused': {
                                transform: 'translate(-16px, -9px) scale(0.75)',
                            },
                            '&.MuiInputLabel-sizeSmall.MuiFormLabel-filled': {
                                transform: 'translate(-16px, -9px) scale(0.75)',
                            },
                            '&.MuiInputLabel-sizeSmall': {
                                transform: 'translate(-16px, 9px) scale(1)',
                            },
                            '&.MuiInputLabel-sizeMedium.Mui-focused': {
                                transform: 'translate(-16px, -9px) scale(0.75)',
                            },
                            '&.MuiInputLabel-sizeMedium.MuiFormLabel-filled': {
                                transform: 'translate(-16px, -9px) scale(0.75)',
                            },
                            '&.MuiInputLabel-sizeMedium': {
                                transform: 'translate(-16px, 9px) scale(1)',
                            },
                        },
                    }),
                },
            },
        },
    };
}
